const Spinner: React.FC = () => {
	return (
		<div className="relative flex h-full w-full items-center justify-center">
			<span className="box-border inline-block h-12 w-12 animate-spin rounded-full border-4 border-white border-b-transparent"></span>
		</div>
	)
}

export default Spinner
